import t from "../locales";
import { Link } from "react-router-dom";
import inti from "../assets/images/inti.png";
import notebookBig from "../assets/images/button_notitieboekje.png";
import target from "../assets/images/target.png";
import treeLogo from "../assets/images/tree_logo_color.svg";

export default function Info() {
  return (
    <div className="screen-generic">
      <div className="screen-generic__top-image-container">
        <span className="screen-generic__top-image-copyright">
          {t("screens_start_image_copyright")}
        </span>
        <img src={inti} alt="inti" className="screen-generic__top-image" />
      </div>
      <div className="screen-generic__content">
        <p className="screen-generic__text">
          {t("screens_info_instructions_1")}
        </p>
        <p className="screen-generic__text">
          {t("screens_info_instructions_2")}
        </p>
        <div className="screen-generic__tile">
          <p className="screen-generic__text screen-generic__text--target-title">
            {t("screens_info_target")}
          </p>
          <p className="screen-generic__text screen-generic__text--name-title">
            {t("screens_info_target_name")}
          </p>
          <img
            className="screen-generic__target-image"
            src={target}
            alt="target"
          />
          <p className="screen-generic__text">{t("secrets_email_value")}</p>
        </div>
        <p className="screen-generic__text">
          {t("screens_info_instructions_3")}
        </p>
        <p className="screen-generic__text">
          {t("screens_info_instructions_4")}
        </p>
        <div className="screen-generic__tile">
          <p className="screen-generic__text screen-generic__text--notebook-title">
            {t("screens_info_notebook_title")}
          </p>
          <img
            className="screen-generic__notebook-image"
            src={notebookBig}
            alt="notebook"
          />
        </div>
        <Link className="button" to={"/apps"}>
          {t("screens_info_button_text")}
        </Link>
      </div>
      <div className="screen-generic__footer">
        <img
          src={treeLogo}
          alt={t("logo_tree")}
          className="screen-generic__logo"
        />
      </div>
    </div>
  );
}
